import { gsap } from 'gsap';

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute();
  if (route.name !== 'yatirimlar') {
    nuxtApp.provide('gsap', gsap); 
  }
});
